import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Radio as MuiRadio, withStyles } from '@material-ui/core';

const styles = theme => ({
  label: {
    color: theme.palette.type === 'light' ? '#19191B' : theme.palette.common.white,
    fontSize: '16px',
    fontWeight: '500',
  },
  disabled: { fontStyle: 'italic' },
  radio: {
    '&:hover': { backgroundColor: '#3A00E50A !important' },
  },
  radioChecked: { color: '#3A00E5 !important' },
});

const propTypes = {
  classes: PropTypes.object.isRequired,
};
const defaultProps = {};

function Radio({ classes, ...rest }) {
  return (
    <FormControlLabel
      classes={{ disabled: classes.disabled, label: classes.label }}
      control={<MuiRadio classes={{ root: classes.radio, checked: classes.radioChecked }} />}
      {...rest}
    />
  );
}

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

export default withStyles(styles)(Radio);
